import { createAsyncThunk } from '@reduxjs/toolkit';

import { getMeQuery } from '../../api/viewer.api';
import type { Viewer } from '../types/viewer';

export const fetchViewerDataThunk = createAsyncThunk<
    Viewer,
    void,
    AsyncThunkConfig<unknown>
>('viewer/initViewerData', async (_, { dispatch, rejectWithValue }) => {
    try {
        return await dispatch(getMeQuery()).unwrap();
    } catch (error) {
        return rejectWithValue(error);
    }
});
